import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { AppSettings } from '../enums/app-settings.enum';
import { AlertService } from '../services/alert.service';
import { LanguageSwitchService } from '../services/language-switch.service';
@Injectable({
  providedIn: 'root',
})
export class UtilitiesService {
  ANURL: string;
  private ENV: any;
  constructor(
    private route: ActivatedRoute,
    private LSS: LanguageSwitchService,
    private ALS: AlertService,
    private toastController: ToastController
  ) {}

  private AHURL: string = `en${AppSettings.APPLICATION_HEADER_URL}`;
  private AFURL: string = `en${AppSettings.APPLICATION_FOOTER_URL}`;

  setAHURL(U: string): void {
    this.AHURL = U;
  }

  getAHURL() {
    return this.AHURL;
  }

  setAFURL(U: string): void {
    this.AFURL = U;
  }
  setANURL(U: string): void {
    this.ANURL = U;
  }

  getAFURL() {
    return this.AFURL;
  }

  getANURL() {
    return this.ANURL;
  }

  public getSelectedLanguage() {
    return new Promise((resolve, reject) => {
      this.route.queryParamMap.subscribe((params) => {
        const token: any = { ...params };
        const lang = token.params.locale
          ? token.params.locale.toLowerCase()
          : undefined;
        if (lang === 'ar') {
          this.LSS.setLanguage('ar');
          this.setAHURL(`ar${AppSettings.APPLICATION_HEADER_URL}`);
          this.setAFURL(`ar${AppSettings.APPLICATION_FOOTER_URL}`);
          this.setANURL(`ar${AppSettings.APPLICATION_NAVIATION_URL}`);
          const urls = {
            APPLICATION_HEADER_URL: 'ar' + AppSettings.APPLICATION_HEADER_URL,
            APPLICATION_FOOTER_URL: 'ar' + AppSettings.APPLICATION_FOOTER_URL,
            APPLICATION_NAVIATION_URL:
              'ar' + AppSettings.APPLICATION_NAVIATION_URL,
          };
          resolve(urls);
        } else {
          this.LSS.setLanguage('en');
          this.setAHURL(`en${AppSettings.APPLICATION_HEADER_URL}`);
          this.setAFURL(`en${AppSettings.APPLICATION_FOOTER_URL}`);
          this.setANURL(`ar${AppSettings.APPLICATION_NAVIATION_URL}`);
          const urls = {
            APPLICATION_HEADER_URL: 'en' + AppSettings.APPLICATION_HEADER_URL,
            APPLICATION_FOOTER_URL: 'en' + AppSettings.APPLICATION_FOOTER_URL,
            APPLICATION_NAVIATION_URL:
              'en' + AppSettings.APPLICATION_NAVIATION_URL,
          };
          resolve(urls);
        }
      });
    });
  }
  getLocaleLanguage(): string {
    const language = this.LSS.getLanguage();
    if (language) return language;
    else {
      if (localStorage.getItem('language')) {
        return localStorage.getItem('language');
      }
    }
    return 'en';
  }

  log(D: any) {
    console.log(D);
  }
  error(E: any) {
    this.ALS.error(E);
    this.toast(E);
  }
  clearError() {
    this.ALS.clearAll();
  }

  getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }
  createCookie(name, value, days) {
    var expires = '';

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = ';expires=' + date.toUTCString();
    }

    document.cookie = name + '=' + value + expires;
    return '';
  }
  async toast(M: string) {
    const toast = await this.toastController.create({
      message: `${M}`,
      duration: 2000,
    });
    toast.present();
  }

  getHeaders() {
    const req = new XMLHttpRequest();
    req.open('GET', window.location.href, false);
    req.send(null);
    const headers = req.getAllResponseHeaders().toLowerCase();
  }

  uniqByKeepLast(a, key) {
    return [...new Map(a.map((x) => [key(x), x])).values()];
  }
  uniqByKeepFirst(a, key) {
    let seen = new Set();
    return a.filter((item) => {
      let k = key(item);
      return seen.has(k) ? false : seen.add(k);
    });
  }
  getBrowserInfo = function () {
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browserName = navigator.appName;
    var fullVersion = '' + parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion, 10);
    var nameOffset, verOffset, ix;

    // In Opera, the true version is after "Opera" or after "Version"
    if ((verOffset = nAgt.indexOf('Opera')) != -1) {
      browserName = 'Opera';
      fullVersion = nAgt.substring(verOffset + 6);
      if ((verOffset = nAgt.indexOf('Version')) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
      browserName = 'Microsoft Internet Explorer';
      fullVersion = nAgt.substring(verOffset + 5);
    }
    // In Chrome, the true version is after "Chrome"
    else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
      browserName = 'Chrome';
      fullVersion = nAgt.substring(verOffset + 7);
    }
    // In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
      browserName = 'Safari';
      fullVersion = nAgt.substring(verOffset + 7);
      if ((verOffset = nAgt.indexOf('Version')) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In Firefox, the true version is after "Firefox"
    else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
      browserName = 'Firefox';
      fullVersion = nAgt.substring(verOffset + 8);
    }
    // In most other browsers, "name/version" is at the end of userAgent
    else if (
      (nameOffset = nAgt.lastIndexOf(' ') + 1) <
      (verOffset = nAgt.lastIndexOf('/'))
    ) {
      browserName = nAgt.substring(nameOffset, verOffset);
      fullVersion = nAgt.substring(verOffset + 1);
      if (browserName.toLowerCase() == browserName.toUpperCase()) {
        browserName = navigator.appName;
      }
    }

    // trim the fullVersion string at semicolon/space if present
    if ((ix = fullVersion.indexOf(';')) != -1)
      fullVersion = fullVersion.substring(0, ix);
    if ((ix = fullVersion.indexOf(' ')) != -1)
      fullVersion = fullVersion.substring(0, ix);

    majorVersion = parseInt('' + fullVersion, 10);
    if (isNaN(majorVersion)) {
      fullVersion = '' + parseFloat(navigator.appVersion);
      majorVersion = parseInt(navigator.appVersion, 10);
    }
    return browserName;
  };

  setENV(e) {
    localStorage.setItem('ENV', e);
  }

  getENV() {
    const e = localStorage.getItem('ENV');
    if (e) {
      if (e == 'mobile') {
        return e;
      } else {
        return 'web';
      }
    } else {
      return 'web';
    }
  }

  setAccessToken(e) {
    localStorage.setItem('AccessToken', e);
  }

  getAccessToken() {
    const e = localStorage.getItem('AccessToken');
    if (e) {
      return e;
    }
    return null;
  }

  
  setJSessionID(e) {
    localStorage.setItem('JSESSIONID', e);
    document.cookie =  'JSESSIONID='+e;
  }

  getJSessionID() {
    const e = localStorage.getItem('JSESSIONID');
    if (e) {
      return e;
    }
    return null;
  }

  isMobileDevice() {
    return /Mobi/i.test(window.navigator.userAgent);
  }

  getMobileOperatingSystem() {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/android/i.test(userAgent)) {
      return 'Android';
    } else {
      return 'iOS';
    }
  }

  format(phoneNumber: any) {
    return phoneNumber
      .replace(/\s+/g, '')
      .replace(/^(.{3})(.{3})(.*)$/, '$1 $2 $3');
  }

}
